import { StyleSheet, I18nManager, Platform, Dimensions } from 'react-native'

import { Colors } from '../Themes';

export default StyleSheet.create({
  containerStyle: {
    marginBottom: 5,
    marginHorizontal: 10,
    marginTop: 20,
  },
  helperTextContainerStyle: {
    flexDirection: 'row',
    marginLeft: 4,
    marginTop: -6,
  },
  helperTextStyle: {
    color: Colors.light_grey,
    flex: 1,
    fontSize: 14.6,
    lineHeight: 18.7,
    marginLeft: I18nManager.isRTL ? 0 : 7,
    marginRight: I18nManager.isRTL ? 7 : 0,
    paddingTop: Platform.OS === 'ios' ? 3 : 1,
  },
  inputContainerStyle: {
    flexDirection: 'row',
  },
  leftIconContainerStyle: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    left: 5,
    position: 'absolute',
    top: 17,
  },
  rightIconContainerStyle: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'absolute',
    right: 10,
    top: 17,
  },
  textInputStyle: {
    flex: 1,
  },
  labelTextStyle: {
    position: 'absolute',
    left: Platform.OS === 'web' ? '51%' : '100%',
  },
});
